import type { ProductType } from './types';

/** Central cache keys so mutations can invalidate precisely. */
export const queryKeys = {
  homepage: ['homepage'] as const,
  products: (filters: { type?: ProductType; featured?: boolean } = {}) =>
    ['products', filters.type ?? null, filters.featured ?? null] as const,
  product: (slug: string) => ['product', slug] as const,
  workshopsFeatured: ['workshops', 'featured'] as const,
  workshop: (slug: string) => ['workshop', slug] as const,
  me: ['me'] as const,
  adminHomepage: ['admin', 'homepage'] as const,
  adminOverview: ['admin', 'overview'] as const,
  adminProducts: (type?: ProductType) => ['admin', 'products', type ?? null] as const,
  adminStudents: ['admin', 'students'] as const,
  adminCoupons: ['admin', 'coupons'] as const,
  adminActivationBatches: ['admin', 'activation-code-batches'] as const,
  adminOrders: ['admin', 'orders'] as const,
  adminBankTransactions: ['admin', 'bank-transactions'] as const,
  adminCourseCurriculum: (courseId: string) => ['admin', 'course-curriculum', courseId] as const,
  adminSkillVersions: (skillId: string) => ['admin', 'skill-versions', skillId] as const,
  adminWorkshops: ['admin', 'workshops'] as const,
  adminWorkshopRegistrations: (workshopId: string) =>
    ['admin', 'workshops', workshopId, 'registrations'] as const,
  library: ['library'] as const,
  cart: ['cart'] as const,
  order: (id: string) => ['order', id] as const,
};
